import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css'; // Optional custom CSS for more styling
import { useTranslation } from 'react-i18next'; // Import useTranslation
const Footer = () => {

    const { t } = useTranslation(); // Get the t function
  return (
    <footer
    className="text-white pt-2 pb-2"
    style={{
      background: 'linear-gradient(to right, rgb(21, 43, 92), rgb(89, 170, 251))',
    }}
  >
    <Container>
      <Row className="text-center text-md-left">
        <Col md={4} className="mb-2">
          <h6 className="text-uppercase mb-2" style={{ fontSize: '14px', fontWeight: 'bold' }}>{t('aboutUs')}</h6>
          <p className="text-white fs-6" style={{ fontSize: '12px', lineHeight: '1.4' }} dangerouslySetInnerHTML={{ __html: t('footer') }} />
        </Col>
  
        <Col md={4} className="mb-2">
          <h6 className="text-uppercase mb-2" style={{ fontSize: '14px', fontWeight: 'bold' }}>Quick Links</h6>
          <ul className="list-unstyled" style={{ fontSize: '12px', lineHeight: '1.6' }}>
            <li><a href="/about" className="text-white text-decoration-none">About Us</a></li>
            <li><a href="/products" className="text-white text-decoration-none">Products</a></li>
            <li><a href="/blogs" className="text-white text-decoration-none">Blogs</a></li>
            <li><a href="/contact" className="text-white text-decoration-none">Contact</a></li>
          </ul>
        </Col>
  
        <Col md={4} className="mb-2">
          <h6 className="text-uppercase mb-2" style={{ fontSize: '14px', fontWeight: 'bold' }}>Contact Info</h6>
          <ul className="list-unstyled" style={{ fontSize: '12px', lineHeight: '1.6' }}>
            <li>📞 +251930415372 / 947090514</li>
            <li>📧 agpipefittingtechnology@gmail.com</li>
            <li>📍 East Africa , Ethiopia , BahirDar </li>
          </ul>
        </Col>
      </Row>
  
      <Row className="align-items-center">
        <Col md={6} className="text-center mb-2">
          <h6 className="text-uppercase mb-2" style={{ fontSize: '14px', fontWeight: 'bold' }}>Follow Us</h6>
          <div className="d-flex justify-content-center">
            <a href="https://facebook.com" className="text-white mx-1"><FaFacebookF size={16} /></a>
            <a href="https://twitter.com" className="text-white mx-1"><FaTwitter size={16} /></a>
            <a href="https://instagram.com" className="text-white mx-1"><FaInstagram size={16} /></a>
            <a href="https://linkedin.com" className="text-white mx-1"><FaLinkedinIn size={16} /></a>
          </div>
        </Col>
  
        <Col md={6} className="text-center">
          <h6 className="text-uppercase mb-2" style={{ fontSize: '14px', fontWeight: 'bold' }}>Our Location</h6>
          <iframe
            title="AG Pipe Fitting Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d985.0768961415773!2d38.775779854740364!3d9.035681043731946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b8fa1b2380663%3A0xaaa775354314a56!2sAg%20Pipe%20Fitting%20Technology%20P%20L%20C!5e0!3m2!1sen!2set!4v1737541748881!5m2!1sen!2set"
            width="100%"
            height="100"
            style={{ border: '0', borderRadius: '8px' }}
            allowFullScreen
            loading="lazy"
          ></iframe>
        </Col>
      </Row>
  
      <Row className="mt-2">
        <Col className="text-center">
          <p className="mb-0" style={{ fontSize: '12px' }}>
            &copy; 2024 AG Pipe Fitting. All Rights Reserved | <a href="https://alyahsoftware.com/">By Alyah Software</a>
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
  
  
  );
};

export default Footer;
